//Vue application works in different modes
export const VUE_APP_MODES = {
    COMPARISON: 1,//Plans comparison page /compare
    PROVIDER: 2,//Plans list on provider page ("Plans" tab)
    PROFILE_CART: 3,//Table in profile
    CART_NON_VUE_ADAPTER: 4,//Adapter, gives opportunity to add/remove
    //plans from cart from scripts outside the Vue
    SPECIAL: 5,
};